import { ClickEvent, Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutJournalDriver } from "./autogen/AutogenLayoutJournalDriver";
import { OrderTabView } from "@mcleod/dispatch";
import { Navigation, StringUtil } from "@mcleod/core";
import { LabelStyles } from "@mcleod/components/src/components/label/LabelStyles";

export class JournalDriver extends AutogenLayoutJournalDriver {

    tableJournalDriverOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const orderIdLabel = tableRow.findComponentById("labelOrderId") as Label;
        if (orderIdLabel != null && !StringUtil.isEmptyString(orderIdLabel.text)) {
            if (orderIdLabel.text?.startsWith("M")) {
                orderIdLabel.tooltip = "Click to view manifest";
            } else {
                orderIdLabel.tooltip = "Click to view order";
            }
            orderIdLabel.setClassIncluded(LabelStyles.link, true);
            orderIdLabel.addUnderlineWhenMouseOver();
        } 

    }

    labelOrderIdOnClick(event: ClickEvent) {
        const orderOrManifestId = (event.target as Label)?.text;
        if (!StringUtil.isEmptyString(orderOrManifestId)) {
            if (orderOrManifestId?.startsWith("M")) {
                Navigation.navigateTo("lme/dispatch/OrderList?manifest_id=" + orderOrManifestId, { newTab: true });
            } else {
                OrderTabView.navigateTo({ key: orderOrManifestId, newTab: true });
            }
        }
    }
}